export const closePanelDataSet = { cy: 'BottomSheet-close-btn' };

export const closeIconPanelDataSet = { cy: 'BottomSheet-close-icon' };
